export default __webpack_public_path__ + "static/media/production-img-4.92bfacf5.png";